import { useCallback, useEffect, useRef } from 'react';

// NCP 네이버 지도 API 타입 정의

const GrowthMap = () => {
    const mapRef = useRef<HTMLDivElement>(null);

    // 지도 초기화
    const initializeMap = useCallback(() => {
        if (!mapRef.current || !window.naver || !window.naver.maps) {
            console.warn('지도 초기화 조건이 충족되지 않았습니다.');
            return;
        }

        try {
            const mapOptions = {
                center: new window.naver.maps.LatLng(37.771811, 128.88946),
                zoom: 17,
                minZoom: 6,
                maxZoom: 21,
                mapTypeId: window.naver.maps.MapTypeId.NORMAL,
                mapDataControl: false,
                scaleControl: true,
                logoControl: true,
                mapTypeControl: true,
                mapTypeControlOptions: {
                    style: window.naver.maps.MapTypeControlStyle.BUTTON,
                    position: window.naver.maps.Position.TOP_RIGHT,
                },
                zoomControl: true,
                zoomControlOptions: {
                    style: window.naver.maps.ZoomControlStyle.LARGE,
                    position: window.naver.maps.Position.TOP_LEFT,
                },
                tileTransition: false,
                tileDuration: 0,
                tileSpare: 0,
                tileFadeEffect: false,
                useStyleMap: false,
                usePanAnimation: false,
                useZoomAnimation: false,
                enableWheelZoom: true,
                backgroundMap: false,
                overlayZoomEffect: 'none',
                useGPUAcceleration: true,
            };

            const naverMap = new window.naver.maps.Map(
                mapRef.current,
                mapOptions,
            );

            // 네이버 지적도 레이어 추가
            const cadastral = new window.naver.maps.CadastralLayer();
            cadastral.setMap(naverMap);

            // 줌 변경 이벤트
            let zoomTimeout: NodeJS.Timeout;
            window.naver.maps.Event.addListener(
                naverMap,
                'zoom_changed',
                (zoom: number) => {
                    clearTimeout(zoomTimeout);
                    zoomTimeout = setTimeout(() => {
                        console.log('줌 레벨 변경:', zoom);

                        // // 현재 보이는 영역의 바운딩 박스 좌표 출력
                        // const bounds = naverMap.getBounds();
                        // const ne = bounds.getNE();
                        // const sw = bounds.getSW();
                        //
                        // console.log('보이는 영역 좌표:', {
                        //     northEast: { lat: ne.lat(), lng: ne.lng() },
                        //     southWest: { lat: sw.lat(), lng: sw.lng() },
                        // });
                    }, 100);
                },
            );

            console.log('NCP 네이버 지도가 성공적으로 초기화되었습니다.');
        } catch (error) {
            console.error('지도 초기화 중 오류:', error);
        }
    }, []);

    useEffect(() => {
        const loadNaverMapScript = () => {
            if (window.naver && window.naver.maps) {
                initializeMap();
                return;
            }

            const existingScript = document.querySelector(
                'script[src*="openapi.map.naver.com"]',
            );
            if (existingScript) {
                existingScript.remove();
            }

            const clientId = import.meta.env.VITE_NCP_API_KEY_ID;
            const script = document.createElement('script');
            script.src = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${clientId}&submodules=geocoder,drawing,geometry`;
            script.type = 'text/javascript';
            script.async = true;

            script.onload = () => {
                console.log('NCP 네이버 지도 API 로드 완료');
                setTimeout(initializeMap, 200);
            };

            script.onerror = error => {
                console.error('NCP 네이버 지도 API 로드 실패:', error);
            };

            document.head.appendChild(script);
        };

        loadNaverMapScript();
        return () => {};
    }, []);

    return (
        <>
            <div ref={mapRef} style={{ minHeight: '320px' }} />
        </>
    );
};

export default GrowthMap;
